@if (!editMode) {
  <div>
    @if (extractedData) {
      <span> {{ extractedData.join(', ') }}</span>
    }
  </div>
} @else {
  @if (fieldConfig) {
    <mat-form-field>
      <mat-select
        #ngModel="ngModel"
        [(ngModel)]="extractedData"
        (ngModelChange)="onModelChange()"
        multiple
        [errorStateMatcher]="matcher">
        @for (option of fieldConfig.options; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
      @for (v of fieldConfig.validators; track v) {
        <mat-error>
          @if (condition(v, ngModel)) {
            <span>{{ message(v) }}</span>
          }
        </mat-error>
      }
    </mat-form-field>
  }
}
